import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.22_@babel+core@7.29.7_@playwright+test@1.62.0_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TipCalculator"] */ "/opt/buildhome/repo/src/components/tools/TipCalculator.tsx");
